<template>
  <mdb-card>
    <mdb-card-header class="text-right entity-card-header p-1">
      <a @click.stop="onCreateMailTextClicked()">
        <mdb-icon icon="envelope" title="Get email template"/>
      </a>
    </mdb-card-header>
    <mdb-card-body class="px-3 pb-2 entity-card-body">
      <ul class="list-unstyled">
        <li class="mb-1 d-flex justify-content-between">
          <mdb-icon icon="clock" class="mr-2"/><span :title="created.full">{{ created.date }}</span>
        </li>
        <template v-for="(rate, i) in quote.rates">
          <li :key="`quote-rate-hr-${i}`"><hr class="my-1"></li>
          <li v-if="rate.type" :key="`quote-rate-type-${i}`" class="d-flex justify-content-between rate-li">
            <mdb-icon icon="circle" class="mr-2"/><span>{{ rate.type }}</span>
          </li>
          <li :key="`quote-rate-route-${i}`" class="d-flex justify-content-between rate-li">
            <mdb-icon icon="route" class="mr-2"/><span>{{ rateRoute(rate) }}</span>
          </li>
          <li :key="`quote-rate-price-${i}`" class="d-flex justify-content-between rate-li">
            <mdb-icon icon="coins" class="mr-2"/>
            <a
              title="Click to change price"
              class="price-link"
              @click.stop="onPriceClicked(rate)"
            >
              {{ ratePrice(rate) }}
            </a>
          </li>
        </template>
      </ul>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import {
  mdbIcon,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
  mdbView,
  mdbMask
} from 'mdbvue'
import {OrderTypes} from '../enums'
import {formatD, formatDT, cargoInfo, errorCatch} from '../utils'
import {mapActions} from 'vuex'

export default {
  name: 'OrderQuote',
  props: {
    context: {
      validator: context => Object.values(OrderTypes).includes(context)
    },
    quote: {
      type: Object,
      required: true
    },
    request: {
      type: Object,
      required: true
    }
  },
  computed: {
    created: function () {
      return { full: formatDT(this.quote.created), date: formatD(this.quote.created) }
    },
    routeInfo: function () {
      let info = ''
      if (this.request.origin && this.request.destination) {
        info += `${this.request.origin.name} - ${this.request.destination.name}\n\n`
        info += `Origin:\t\t${this.request.origin.commonName}\n`
        info += `Destination:\t${this.request.destination.commonName}\n`
      } else if (this.request.place) {
        info += `${this.request.place.name}\n\n`
        info += `Place:\t${this.request.origin.commonName}\n`
      }
      return info
    }
  },
  methods: {
    ...mapActions(['apiOrderQuoteSetRatePrice']),
    rateRoute (rate) {
      if (rate.origin && rate.destination) {
        return `${rate.origin.name} - ${rate.destination.name}`
      }
      if (rate.place) {
        return rate.place.name
      }
      return 'n/a'
    },
    ratePrice (rate) {
      return `${rate.price.toFixed(2)} ${rate.currency}`
    },
    onCreateMailTextClicked () {
      const cargoInf = this.request.cargos.map(crg => {
        return `- ${cargoInfo(crg)}`
      }).join('\n')
      const ratesInfo = this.quote.rates.map(rate => {
        return `- ${rate.name} — ${rate.price.toFixed(2)} ${rate.currency}\n  ${rate.agent ? `Agent:\t"${rate.agent.name}"` : ''}\n  ${rate.airline ? `Airline:\t"${rate.airline.name}"` : ''}`
      }).join('\n')
      this.$emit('create-mail-text', `Your route: ${this.routeInfo}\nYour cargo:\n${cargoInf}\n\nSuggested rates:\n${ratesInfo}`)
    },
    onPriceClicked (rate) {
      this.$bus.$emit(
        'modal-price',
        {
          price: rate.price,
          currency: rate.currency,
          callback: price => {
            this.apiOrderQuoteSetRatePrice(
              {
                quoteUuid: this.quote.uuid,
                rateUuid: rate.uuid,
                price: parseFloat(price.toString())
              }
            ).then(() => {
              this.$emit('rate-price-changed')
            }).catch(errorCatch('Failed to Change Rate Price', this))
          }
        }
      )
    }
  },
  components: {
    mdbIcon,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    mdbView,
    mdbMask
  }
}
</script>

<style lang="sass" scoped>
.entity-card-header
  font-size: 75%

.entity-card-body
  font-size: 75%

  .rate-li
    font-size: 75%

.price-link
  text-decoration: underline!important

  &:hover
    cursor: pointer
    color: aqua!important
</style>

<style lang="sass">
.mail-text-modal-textarea

  textarea
    font-size: 75%
    height: 17rem!important
</style>



// WEBPACK FOOTER //
// src/components/OrderQuote.vue